/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-04-24 10:17:41
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-04-24 10:30:00
 */
import { useState, useRef } from 'react'
import { Photos } from '../types'

export interface ViewerState {
  activeIndex: number
  scale: number
  rotate: number
  watermarks: any[]
  folders: any[]
  watermarkLoading: boolean
  authorUserId: string
  saveLoading: boolean
  isFullScreen: boolean
  isHideInfo: boolean
  showFavoriteTooltip: boolean
  visible: boolean
  isShowAddToFolderBtn: boolean
  removeWatermarkModalStatus: {
    visible: boolean
    taskID: string | null
    fileName: string
  }
  showHdButton: boolean
  aiProcessing: boolean
  isComparisonMode: boolean
  originalIndexBeforeComparison: number | null
  originalPhotos: Photos | null
  aiProcessingFailed: boolean
}

export function useViewerState() {
  // 状态管理
  const [state, setState] = useState<ViewerState>({
    activeIndex: -1,
    scale: 100,
    rotate: 0,
    watermarks: [],
    folders: [],
    watermarkLoading: true,
    authorUserId: '',
    saveLoading: false,
    isFullScreen: false,
    isHideInfo: true,
    showFavoriteTooltip: false,
    visible: false,
    isShowAddToFolderBtn: false,
    removeWatermarkModalStatus: {
      visible: false,
      taskID: null,
      fileName: ''
    },
    showHdButton: false,
    aiProcessing: false,
    isComparisonMode: false,
    originalIndexBeforeComparison: null,
    originalPhotos: null,
    aiProcessingFailed: false
  })

  // refs
  const imgRef = useRef<HTMLImageElement>(null)
  const mouseDown = useRef(false)
  const downPosition = useRef<{ x: number; y: number } | null>(null)
  const movement = useRef<{ x: number; y: number }>({ x: 0, y: 0 })
  const offsetX = useRef(0)
  const offsetY = useRef(0)
  const currentVisible = useRef(false)
  const wmTimer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const lastTaskCreationTime = useRef<number | null>(null)
  const currentTaskId = useRef<string | null>(null)
  const originalPhotos = useRef<Photos | null>(null)

  // 附加状态跟踪变量
  const [scaleChanged, setScaleChanged] = useState(false)
  const [hdButtonChanged, setHdButtonChanged] = useState(false)

  return {
    state,
    setState,
    imgRef,
    mouseDown,
    downPosition,
    movement,
    offsetX,
    offsetY,
    currentVisible,
    wmTimer,
    lastTaskCreationTime,
    currentTaskId,
    originalPhotos,
    scaleChanged,
    setScaleChanged,
    hdButtonChanged,
    setHdButtonChanged
  }
}
